// @meiden-connect/ui の useShowToast と同一シグネチャの差し替え用フック。
// 呼び出し元を無改変にするため、`showToast(level, message)` の形をそのまま踏襲する。
// 実体は notice-store（自前のお知らせ表示）へお知らせを積むだけ。

import { useNoticeStore, type NoticeLevel } from "./notice-store";

export type ShowToast = (level: NoticeLevel, message: string) => void;

export function useShowToast(): ShowToast {
  // push はストア生成時に固定される安定参照のため、そのまま返してよい。
  return useNoticeStore((s) => s.push);
}
